import { render, staticRenderFns } from "./ChallengeParentControls.vue?vue&type=template&id=29a25986&"
import script from "./ChallengeParentControls.vue?vue&type=script&lang=js&"
export * from "./ChallengeParentControls.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeParentControls.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports